module.exports = __webpack_public_path__ + "static/img/3538_phase_function_Paper_PointsHejduk_Prediction.0855bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3538_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nJyU
// module chunks = 0